import {Tax} from "./tax";
/**
 * Created by alex.y on 8/8/2017.
 */
export class OrderTotal {
    public TotalPrice: number;
    public Taxes: Array<Tax> = [];
    public CurrentRate: number;
}


// WEBPACK FOOTER //
// ./app/objects/orders/orderTotal.ts